// FILE: homeGreeting.ts
// Purpose: Build the home page greeting from whatever the account happens to
//          carry as a name.
// Layer: Web lib (pure)
// Exports: resolveGreetingName, homeGreetingTitle

/**
 * First name for a greeting, or `null` when there is nothing usable.
 *
 * `AuthenticatedUser.name` is free text: it can be a full name, an email-ish
 * handle, or whitespace. Greeting someone by their full legal name every time
 * they open the app reads like a bank letter, so only the first token is kept.
 */
export function resolveGreetingName(name: string | null | undefined): string | null {
  if (!name) return null;
  const firstToken = name.trim().split(/\s+/u)[0];
  if (!firstToken) return null;
  return firstToken;
}

/**
 * The greeting line. Without a name it stays a greeting rather than growing a
 * placeholder: "Hola." is a complete sentence, "Hola, ." is a bug on screen.
 */
export function homeGreetingTitle(name: string | null | undefined): string {
  const greetingName = resolveGreetingName(name);
  return greetingName ? `Hola, ${greetingName}.` : "Hola.";
}
